<template>
    <div>
        <b-row class="card-container">
            <b-col class="col-12 d-flex justify-content-center">
                <i class="icon-content" :class="block.icon"></i>
            </b-col>
            <b-col class="col-12 d-flex justify-content-center">
                <h3>{{ block.name }}</h3>
            </b-col>
            <b-col class="col-12 progress-container">
                <ProgressBar
                    class="progress-bar"
                    :value="block.performance == null ? 0 : block.performance"
                    height=".7rem"
                    :label="viewBlockPerformance"
                    :labelColor="updateColorPerformance"
                    :color="updateColorPerformance"
                    :max="maxProgressBar"
                ></ProgressBar>
                <span>{{ viewBlockPerformance }}</span>
            </b-col>
        </b-row>
        <b-row v-if="block.attributes.length > 0">
            <b-col class="col-12">
                <AttributeCard :attributes="block.attributes" />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import ProgressBar from '@/views/components/progress-bar/ProgressBar.vue'
import AttributeCard from './AttributeCard'
export default {
    name: 'CardCompact',
    components: {
        ProgressBar,
        AttributeCard,
    },
    props: {
        block: {
            type: Object,
        },
    },
    computed: {
        viewBlockPerformance() {
            let valuePerformance = (this.block.performance * 100).toFixed(0)
            return `${valuePerformance}%`
        },
        updateColorPerformance() {
            return this.block.performance == null || this.block.performance == 0
                ? '#F0F3F5'
                : this.block.performance < 0.3
                ? '#f05050'
                : this.block.performance < 0.7
                ? '#fad732'
                : '#27c24c'
        },
    },
    data() {
        return {
            maxProgressBar: 1,
        }
    },
}
</script>

<style lang="sass" scoped>
.card-container
    margin-bottom: 1rem
.icon-content
    font-size: 1rem
    color: #66C2E9
    text-align: center
    margin-bottom: .5rem
.progress-container
    display: flex
    justify-content: center
    align-items: center
    column-gap: .5rem
    span
        color: #6E6E6E
    .progress-bar
        background: #F0F3F5 !important
        min-width: 200px
</style>
